import React, { Component } from "react";
import { Segment, List, Item, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";
// import AttendeeListModal from "../UserDetail/UserActivity/UserActivityDashboardComponents/AttendeeListModal";
import SidebarAttendeeModal from "./SidebarAttendeeModal";

class TestDetailSidebar extends Component {
    state = {
        openModal: false
    };
    attendeeListDisplay = [];
    attendeeListModal = [];

    componentWillReceiveProps() {
        const { attendees } = this.props;
        console.log("componentDidMount() attendees ", attendees.length);
        if (attendees.length > 2) {
            this.attendeeListDisplay = attendees.slice(0, 2);
            this.attendeeListModal = attendees.slice(2, attendees.length);
            // console.log("activity activity activity ", activity);
            console.log("list item displayed ", this.attendeeListDisplay);
            console.log("list item for modal ", this.attendeeListModal);
        } else {
            this.attendeeListDisplay = attendees;
        }
    }

    closeModal = () => {
        this.setState({
            openModal: false
        });
    };

    showModal = attendeeListModal => () => {
        console.log("showModal() ", attendeeListModal);
        this.setState({
            openModal: true
        });
    };

    render() {
        const { attendees } = this.props;
        return (
            <div>
                <Segment
                    textAlign="center"
                    style={{ border: "none" }}
                    attached="top"
                    secondary
                    inverted
                    color="teal"
                >
                    {attendees && attendees.length}{" "}
                    {attendees && attendees.length === 1 ? "Person" : "People"}{" "}
                    attended
                </Segment>
                <Segment attached>
                    <List relaxed divided>
                        {/* <Item style={{ position: "relative" }}>
                            <Item.Image size="tiny" src="/assets/user.png" />
                            <Item.Content verticalAlign="middle">
                                <Item.Header as="h3">
                                    2 People Attended
                                </Item.Header>
                            </Item.Content>
                        </Item> */}

                        {this.attendeeListDisplay &&
                            this.attendeeListDisplay.map(attendee => (
                                <Item
                                    key={attendee.id}
                                    style={{ position: "relative" }}
                                >
                                    <Item.Image
                                        size="tiny"
                                        src={
                                            attendee.photoURL ||
                                            "/assets/user.png"
                                        }
                                    />
                                    <Item.Content verticalAlign="middle">
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between"
                                            }}
                                        >
                                            <div>
                                                <Item.Header as="h3">
                                                    <Link
                                                        to={`/profile/${
                                                            attendee.id
                                                        }`}
                                                    >
                                                        {
                                                            attendee.values
                                                                .displayName
                                                        }
                                                    </Link>
                                                </Item.Header>
                                            </div>
                                            <div>
                                                <Item.Header as="h3">
                                                    <Link
                                                        to={`/profile/${
                                                            attendee.id
                                                        }`}
                                                    >
                                                        {
                                                            attendee.values
                                                                .testScore
                                                        }
                                                    </Link>
                                                </Item.Header>
                                            </div>
                                        </div>
                                    </Item.Content>
                                </Item>
                            ))}
                    </List>
                    {this.attendeeListModal.length > 0 && (
                        <Button
                            primary
                            onClick={this.showModal(this.attendeeListModal)}
                            style={{
                                margin: "auto",
                                width: "100%"
                            }}
                        >{`+${this.attendeeListModal.length} more`}</Button>
                    )}
                    <SidebarAttendeeModal
                        open={this.state.openModal}
                        attendees={this.attendeeListModal}
                        close={this.closeModal}
                    />
                </Segment>
            </div>
        );
    }
}

export default TestDetailSidebar;
